/**
 * Central configuration for AI agents and models
 * Used by: ProjectSettings, AnalyzeModal, ImplementModal
 */

// AI Agent providers
export const AI_AGENTS = {
  CLAUDE: 'claude',
  CODEX:  'codex',
  GEMINI: 'gemini',
};

// Claude API models (Anthropic direct). IDs must be valid SDK identifiers
// — short aliases (e.g. 'sonnet-4.6') are normalized to the dated SDK id
// in packages/core/src/constants.js CLAUDE_MODEL_MAP. Latest first.
export const CLAUDE_MODELS = [
  { id: 'claude-opus-4-7',            name: 'Claude Opus 4.7' },
  { id: 'claude-sonnet-4-6',          name: 'Claude Sonnet 4.6 (Recommended)' },
  { id: 'claude-opus-4-6',            name: 'Claude Opus 4.6' },
  { id: 'claude-sonnet-4-5-20250929', name: 'Claude Sonnet 4.5' },
  { id: 'claude-opus-4-5-20251101',   name: 'Claude Opus 4.5' },
  { id: 'claude-haiku-4-5-20251001',  name: 'Claude Haiku 4.5' },
];

// Codex CLI / OpenAI models. Aliases MUST match
// packages/core/src/constants.js CODEX_MODEL_MAP — keep in lockstep.
// Codex CLI passes the model verbatim to OpenAI's API; unmapped values
// pass-through, so adding a new id here works as long as OpenAI accepts
// it. Latest first.
export const CODEX_MODELS = [
  { id: 'gpt-5.5',        name: 'GPT-5.5' },
  { id: 'gpt-5.4',        name: 'GPT-5.4' },
  { id: 'gpt-5.3',        name: 'GPT-5.3' },
  { id: 'gpt-5.3-codex',  name: 'GPT-5.3 Codex' },
  { id: 'gpt-5.2-codex',  name: 'GPT-5.2 Codex' },
  { id: 'gpt-5.2',        name: 'GPT-5.2' },
  { id: 'o4-mini',        name: 'o4-mini' },
  { id: 'o3',             name: 'o3' },
  { id: 'o3-mini',        name: 'o3-mini' },
  { id: 'codex-mini',     name: 'codex-mini' },
  { id: 'gpt-4o',         name: 'GPT-4o' },
  { id: 'gpt-4o-mini',    name: 'GPT-4o mini' },
];

// Gemini CLI / Google Gemini models. Aliases must match
// packages/core/src/constants.js GEMINI_MODEL_MAP — keep in lockstep.
export const GEMINI_MODELS = [
  { id: 'gemini-3-pro',     name: 'Gemini 3 Pro (Recommended)' },
  { id: 'gemini-3-flash',   name: 'Gemini 3 Flash' },
  { id: 'gemini-2.5-pro',   name: 'Gemini 2.5 Pro' },
  { id: 'gemini-2.5-flash', name: 'Gemini 2.5 Flash' },
];

// Get models for a specific agent
export const getModelsForAgent = (agent) => {
  if (agent === AI_AGENTS.CLAUDE) return CLAUDE_MODELS;
  if (agent === AI_AGENTS.CODEX)  return CODEX_MODELS;
  if (agent === AI_AGENTS.GEMINI) return GEMINI_MODELS;
  return CLAUDE_MODELS;
};

// REMOVED: getDefaultModelForAgent. It answered "which model when nobody
// picked one" — and every consumer used it to preseed a picker, which made
// the submitted value look like a deliberate choice. Pickers now open
// unselected; a run uses the model someone chose, or it refuses.
